import { createSelector, createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"

type View = "grid" | "table"

type AircraftSlice = {
    view: View
    page: number
    search: string
    tab: "overview" | "history" | "maintenance"
}

const initialState: AircraftSlice = {
    view: "grid",
    page: 1,
    search: "",
    tab: "overview",
}

export const aircraftSliceName = "aircraft" as const

export const {
    actions: { setView, setAircraftPage, setSearch, setTab },
    reducer: AircraftSliceReducer,
} = createSlice({
    name: aircraftSliceName,
    initialState,
    reducers: {
        setView: (state, action: { payload: AircraftSlice["view"] }) => {
            state.view = action.payload
        },
        setAircraftPage: (state, action: { payload: number }) => {
            state.page = action.payload
        },
        setSearch: (state, action: { payload: AircraftSlice["search"] }) => {
            state.search = action.payload
        },
        setTab: (state, action: { payload: AircraftSlice["tab"] }) => {
            state.tab = action.payload
        },
    },
})

const root = (state: RootState) => state[aircraftSliceName]

export const selectView = createSelector([root], (s) => s.view)
export const selectAircraftPage = createSelector([root], (s) => s.page)
export const selectSearch = createSelector([root], (s) => s.search)
export const selectTab = createSelector([root], (s) => s.tab)
